export default "__VITE_ASSET__4f2f88ca__"